module.exports = __webpack_public_path__ + "img/info.fe4fb0b6.svg";